var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMaps(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM15 19l-6-2.11V5l6 2.11V19z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIwLjUgM0wyMC4zNCAzLjAzTDE1IDUuMUw5IDNMMy4zNiA0LjlDMy4xNSA0Ljk3IDMgNS4xNSAzIDUuMzhWMjAuNUMzIDIwLjc4IDMuMjIgMjEgMy41IDIxTDMuNjYgMjAuOTdMOSAxOC45TDE1IDIxTDIwLjY0IDE5LjFDMjAuODUgMTkuMDMgMjEgMTguODUgMjEgMTguNjJWMy41QzIxIDMuMjIgMjAuNzggMyAyMC41IDNaTTE1IDE5TDkgMTYuODlWNUwxNSA3LjExVjE5WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { SvgMaps as ReactComponent };